import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, Link as MuiLink, Stack, SvgIcon } from '@mui/material';
import { Instagram, Twitter, YouTube, LinkedIn } from '@mui/icons-material';
import LogoText from '../../assets/logo-text.svg';

// Custom TikTok icon
const TikTokIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.298-.002.595.042.88.13V9.4a6.13 6.13 0 0 0-1-.08A6.25 6.25 0 0 0 3 15.57a6.25 6.25 0 0 0 10.95 4.14.25.25 0 0 0 .05-.08 6.22 6.22 0 0 0 .58-2.62v-7.5a8.51 8.51 0 0 0 5.19 1.74V8.11a5.08 5.08 0 0 1-2.93-.87 4.9 4.9 0 0 1-.98-.82" />
  </SvgIcon>
);

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: '#5b4468', // Using the darkest purple for footer
        color: 'white',
        py: { xs: 1, sm: 1.5 },
        borderTop: '1px solid rgba(255,255,255,0.1)'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',  
          alignItems: 'center',
          gap: { xs: 0.75, sm: 2 }
        }}>
          {/* Quick Links - Left */}
          <Stack 
            direction="row" 
            spacing={2} 
            sx={{ 
              order: { xs: 2, sm: 1 },
              fontSize: '0.8rem',
              py: { xs: 0.5, sm: 0 },
              flex: 1,
              alignItems: 'center'
            }}
          >
            <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
              <img src={LogoText} alt="Narrow Gate" style={{ height: '35px', width: 'auto', filter: 'brightness(0) invert(1)', opacity: 0.9 }} />
            </Box>
            <MuiLink component={Link} to="/" color="inherit" sx={{ opacity: 0.7, '&:hover': { opacity: 1, transform: 'translateY(-1px)' }, transition: 'all 0.2s ease' }}>
              Home
            </MuiLink>
            <MuiLink component={Link} to="/schedule" color="inherit" sx={{ opacity: 0.7, '&:hover': { opacity: 1, transform: 'translateY(-1px)' }, transition: 'all 0.2s ease' }}>
              Schedule
            </MuiLink>
            <MuiLink component={Link} to="/gallery" color="inherit" sx={{ opacity: 0.7, '&:hover': { opacity: 1, transform: 'translateY(-1px)' }, transition: 'all 0.2s ease' }}>
              Gallery
            </MuiLink>
            <MuiLink component={Link} to="/contact" color="inherit" sx={{ opacity: 0.7, '&:hover': { opacity: 1, transform: 'translateY(-1px)' }, transition: 'all 0.2s ease' }}>
              Contact
            </MuiLink>
            <MuiLink component={Link} to="/admin" color="inherit" sx={{ opacity: 0.5, '&:hover': { opacity: 0.8, transform: 'translateY(-1px)' }, transition: 'all 0.2s ease', ml: 1 }}>
              Admin
            </MuiLink>
          </Stack>

          {/* Social Media - Center */}
          <Stack direction="row" spacing={1.5} sx={{ 
            order: { xs: 1, sm: 2 },
            justifyContent: 'center',
            flex: 1,
            mx: 'auto'
          }}>
            <MuiLink href="https://tiktok.com/@middiesgetbiddies" target="_blank" color="inherit" sx={{ opacity: 0.7, '&:hover': { opacity: 1 } }}>
              <TikTokIcon sx={{ fontSize: '1.2rem' }} />
            </MuiLink>
            <MuiLink href="https://www.instagram.com/narrowgate.basketball/" target="_blank" color="inherit" sx={{ opacity: 0.7, '&:hover': { opacity: 1 } }}>
              <Instagram sx={{ fontSize: '1.2rem' }} />
            </MuiLink>
            <MuiLink href="https://twitter.com" target="_blank" color="inherit" sx={{ opacity: 0.7, '&:hover': { opacity: 1 } }}>
              <Twitter sx={{ fontSize: '1.2rem' }} />
            </MuiLink>
            <MuiLink href="https://www.youtube.com/watch?v=YFUzTnReH9I" target="_blank" color="inherit" sx={{ opacity: 0.7, '&:hover': { opacity: 1 } }}>
              <YouTube sx={{ fontSize: '1.2rem' }} />
            </MuiLink>
          </Stack>

          {/* Copyright and Credits - Right */}
          <Stack spacing={0.5} sx={{ 
            order: { xs: 3, sm: 3 },
            textAlign: 'center',
            pt: { xs: 0.5, sm: 0 },
            flex: 1
          }}>
            <Typography variant="body2" sx={{ 
              opacity: 0.7, 
              fontSize: '0.75rem',
              textAlign: 'center'
            }}>
              {new Date().getFullYear()} Narrow Gate Basketball
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <MuiLink 
                href="https://www.linkedin.com/in/devin-spahn-65413a2a8" 
                target="_blank" 
                underline="none" 
                color="inherit"
                sx={{ 
                  opacity: 0.5, 
                  fontSize: '0.7rem',
                  letterSpacing: '0.02em',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  '&:hover': { 
                    opacity: 0.7,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                Designed by Devin Spahn <LinkedIn sx={{ fontSize: '0.8rem' }} />
              </MuiLink>
            </Box>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
